import React from 'react';
import AndroidIcon from '@mui/icons-material/Android';
import AppleIcon from '@mui/icons-material/Apple';
import './appDownloadBanner.scss';

const AppDownloadBanner = () => (
    <div className="app-download-banner">
        <p className="app-download-title">Mobil ilovani yuklab oling</p>
        <div className="app-download-buttons">
            <a
                href="https://play.google.com/store/apps/details?id=com.zakovat_savollari"
                target="_blank"
                rel="noopener noreferrer"
                className="app-download-btn android"
            >
                <AndroidIcon />
                <span>
                    <small>Google Play</small>
                    Yuklab olish
                </span>
            </a>
            <a
                href="https://apps.apple.com/us/app/zakovat-savollari/id6780629115"
                target="_blank"
                rel="noopener noreferrer"
                className="app-download-btn ios"
            >
                <AppleIcon />
                <span>
                    <small>App Store</small>
                    Yuklab olish
                </span>
            </a>
        </div>
    </div>
);

export default AppDownloadBanner;